const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      name: "도어락 문제해결",
      // txt2: '오래경험과 노하우 + 최신장비를 활용하여',
      // txt3: '보다 높은 확률로 탐지해냅니다.',
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=24",
    },
    {
      img: "/images/service2.png",
      name: "열쇠 문제해결",
    },
    {
      img: "/images/service3.png",
      name: "잠금장치 문제해결",
    },
  ];

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="flex items-end justify-center gap-0.5 font-medium text-black">
          <img
            alt="키플레이어 도어락 로고"
            className="!relative w-auto h-full flex-wrap lg:flex-nowrap max-h-8 lg:max-h-12 py-1 object-contain cursor-pointer"
            src="/images/logo.png"
            width={531}
            height={65}
          />
          <span className="-mb-1.5 lg:-mb-2">서비스 목록</span>
        </h2>
        <p className="my-3 lg:my-5 lg:text-lg">- SERVICE -</p>
      </div>
      <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
        {serviceList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full mb-5 text-center"
          >
            <div className="relative w-full h-fit p-3 border rounded-3xl btn6 inline-block">
              <div className=" relative w-full h-fit my-3 xl:my-5">
                <p className="text-sm mb-1 xl:mb-2">SERVICE - 0{i + 1}</p>
                <p className="gmedium text-2xl 2xl:text-3xl text-black mb-3">
                  {v.name}
                </p>
              </div>
              <div className="relative w-full h-fit rounded-3xl overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                  alt={`키플레이어 ${v.name}`}
                  src={v.img}
                  width={611}
                  height={589}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
